import { SUBJECT_CATEGORIES } from "../../../../1_BSZFinderApp/components/sectionCards/werHilftSection/config/subjectConfig";

import dayjs from "dayjs";

/**
 * =========================================================
 * ✅ prepare project data for timeline row
 * =========================================================
 */
export function enrichTimelineProject(project, schoolYearStart) {
  return {
    ...project,

    startWeek: dayjs(project.startDate)
      .startOf("isoWeek")
      .diff(schoolYearStart, "week"),

    endWeek: dayjs(project.dueDate)
      .startOf("isoWeek")
      .diff(schoolYearStart, "week"),
  };
}

/**
 * =========================================================
 * ✅ GET SUBJECT CATEGORY
 * =========================================================
 */
export function getSubjectCategory(subjectName, theme) {
  for (const [category, subjects] of Object.entries(SUBJECT_CATEGORIES)) {
    if (subjects.includes(subjectName)) {
      return category;
    }
  }

  return "Sonstiges";
}

/**
 * =========================================================
 * ✅ GET SUBJECT COLOR
 * =========================================================
 */
export function getSubjectColor(subjectName, theme) {
  const category = getSubjectCategory(subjectName);

  const categoryColors = {
    Sprachen: theme.palette.levels.blue,
    Naturwissenschaften: theme.palette.levels.green,
    Geisteswissenschaften: theme.palette.levels.yellow,
    Wirtschaft: theme.palette.levels.orange,
    "Kunst & Sport": theme.palette.levels.purple,
    Sonstiges: theme.palette.levels.lightGreen,
  };

  return categoryColors[category] || categoryColors.Sonstiges;
}
